import React, { useState } from 'react'
import Header from './TableComponents/Header/Header'
import ProductTable from './TableComponents/ProductTable/Table'

const Index = () => {
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [filterLoading, setFilterLoading] = useState(false);

  // Handle filter changes from GlobalInventoryFilter
  const handleFilterChange = (newFilters) => {
    setFilterLoading(true);
    setFilters(newFilters);
    // Simulate loading delay
    setTimeout(() => setFilterLoading(false), 500);
  };

  // Handle search changes from GlobalInventoryFilter
  const handleSearchChange = (searchValue) => {
    setSearchTerm(searchValue);
  };

  return (
    <>
      <Header 
        onFilter={handleFilterChange}
        onSearch={handleSearchChange}
        filterLoading={filterLoading}
      />
      <ProductTable 
        filters={filters}
        searchTerm={searchTerm}
      />
    </>
  )
}

export default Index